import React from 'react'
import PropTypes from 'prop-types'

export default function PanelFieldTextListValue(props) {
  const { value } = props

  return value.map((v) => <div key={v}>{v}</div>)
}

PanelFieldTextListValue.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
}
